<template>
  <perfect-scrollbar id="users" class="content">
    <SkAnimation v-if="loading" :thumb="false" :tab="false"/>
    <div v-else class="listingCnt">
      <div class="listingItemCnt">
        <table>
          <tr>
            <th class="th1">Store</th>
            <th>Location</th>
            <th colspan="2">Contact</th>
          </tr>
          <tbody>
            <tr>
              <td colspan="4" class="tdHeader">
                <div class="listingHeader">
                  <a href="#" v-on:click.prevent="addNewStore" class="lhItem addContent">
                    + Add new content...
                  </a>
                  <div class="clear"></div>
                </div>
              </td>
            </tr>
            <tr v-for="(item, index) in results" :key="index">
              <td class="td1">
                {{item.code}}
                <p v-if="item.name">{{item.name}}</p>
              </td>
              <td class="location">
                <div v-html="item.address" class="address"></div>
                <div class="city">{{item.city}}, {{item.province}}</div>
              </td>
              <td>
                {{item.phone}}
                <a class="viewMap" v-if="item.google_map_link"
                  :href="item.google_map_link" target="_blank">View on google map</a>
              </td>
              <td>
                <div class="action" v-on:click="itemOpenedId = item.id"></div>
                <div :class="{actionOverlay: true, open: itemOpenedId == item.id}"
                  v-on:click="itemOpenedId = null"></div>
                <div :class="{actionCnt: true, open: itemOpenedId == item.id}">
                  <div class="actionItem" v-on:click="editData(index, item)">
                    <img src="../assets/edit-black.png"> Edit Data
                  </div>
                  <div class="divider"></div>
                  <div class="actionItem actionRed" v-on:click="deleteData(index, item)">
                    <img src="../assets/delete.png"> Delete
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <FormInputerShort ref="formInputer"/>
    <StoreEditor ref="storeEditor"/>
  </perfect-scrollbar>
</template>

<script>
import { mapActions } from 'vuex';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import SkAnimation from '@/components/SkAnimation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import StoreEditor from '@/components/StoreEditor.vue';

export default {
  name: 'home',
  components: {
    Confirmation,
    Snackbar,
    SkAnimation,
    FormInputerShort,
    StoreEditor,
  },
  data() {
    return {
      loading: true,
      results: [],
      itemOpenedId: null,
      roles: [],
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    deleteData(i, item) {
      this.itemOpenedId = null;
      const name = (item.code) ? item.code : 'Store';
      this.$refs.confirmDialog.open({
        title: 'Delete Store',
        desc: `Are you sure you want to delete ${name}?
          This operation can not be undone.`,
      }, (b) => {
        if (b) this.deleteNow(i, item);
      });
    },
    deleteNow(i, item) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: `To prevent from accidentally deleted store,
          you need to input your password.`,
        placeholder: 'Password',
        type: 'password',
        action: 'Delete User',
      }, (b) => {
        if (!b) return;
        this.results.splice(i, 1);
        this.$http.get(this.$config.uri(`misc/amway-store/${item.id}/delete`)).then((r) => {
          if (r.data.status !== 200) {
            // Display error
            return;
          }
          this.$refs.snackbar.open({ content: 'Store has been deleted.' });
        });
      });
    },
    addNewStore() {
      this.$refs.storeEditor.open(null, (b, store) => {
        if (b) this.results.unshift(store);
      });
    },
    editData(i, item) {
      this.itemOpenedId = null;
      this.$refs.storeEditor.open(item, (b, store) => {
        if (b) this.getData();
      });
    },
    getData() {
      this.$http.get(this.$config.uri('misc/amway-store')).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
      });
    },
  },
  mounted() {
    this.chTitle('Amway Store');
    this.chCGB(false);
    this.getData();
  },
};
</script>


<style scoped lang="scss">
  .listingItemCnt{
    margin: 0 -30px;
  }
  .listingHeader{
    padding: 5px 20px;
    padding-left: 18px;
    .exportAll{
      float: right;
      background-color: #0057d8;
      font-size: 15px;
      margin-right: 10px;
      padding: 8px 16px;
      border-radius: 40px;
      transition: all .2s linear;
      color: #fff;
      cursor: pointer;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
    .exportAll:hover{
      background-color: #0067ff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    }
    .lhItem{
      font-size: 15px;
      float: left;
      margin-right: 10px;
      padding: 6px 16px;
      border-radius: 40px;
      opacity: .5;
      transition: all .2s linear;
      display: block;
      cursor: pointer;
      position: relative;
      float: none;
      margin-right: 0;
      color: #444;
      img{
        height: 20px;
        margin-bottom: -4px;
        margin-right: 5px;
      }
      .checkAll{
        width: 14px; height: 14px;
        border: #777 2px solid;
        border-radius: 4px;
        float: left;
        margin-right: 10px;
      }
    }
    .lhItem:hover{
      // background-color: #eee;
      opacity: 1;
    }
  }
  table{
    border-collapse: collapse;
    width: 100%;
    tr{
      th{
        text-align: left;
        font-weight: bold;
        color: #999;
        padding: 10px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        text-transform: uppercase;
      }
      th.th1{
        padding-left: 30px;
      }
      td{
        padding: 14px 0;
        padding-left: 20px;
        border-bottom: #eee 1px solid;
        position: relative;
        white-space: nowrap;
        &.location{
          .address{
            max-width: 260px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
            font-size: 16px;
            height: 20px;
            color: #767676;
          }
          .city{
            max-width: 260px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
            font-size: 16px;
          }
        }
        &.td1{
          padding-left: 30px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 200px;
          font-weight: 600;
          p{
            margin: 2px 0 0;
            font-weight: normal;
            color: #767676;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 200px;
          }
        }
        .viewMap{
          display: block;
          margin-top: 3px;
          font-size: 14px;
          padding-left: 18px;
          position: relative;
          color: #767676;
          &:before{
            position: absolute;
            display: block;
            content: "";
            width: 14px; height: 14px;
            left: 0; top: 2px;
            background-image: url(../assets/marker.png);
            background-size: contain;
            opacity: .4;
          }
          &:hover{
            color: #444;
            &:before{
              opacity: .6;
            }
          }
        }
        .action{
          position: absolute;
          right: 14px;
          top: 6px;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background-image: url(../assets/more.png);
          background-size: 18px auto;
          background-repeat: no-repeat;
          background-position: center;
          opacity: .4;
          cursor: pointer;
        }
        .action:hover{
          background-color: #ddd;
          opacity: .7;
        }
        .actionCnt{
          position: absolute;
          background: #fff;
          top: 40px;
          // border: 1px solid #ccc;
          box-shadow: 1px 1px 4px rgba(0,0,0,.2);
          border-radius: 10px;
          padding: 10px 0;
          white-space: nowrap;
          text-align: left;
          right: 14px;
          z-index: 4;
          margin-top: -5px;
          display: none;
          .divider{
            border-top: #eee 1px solid;
            padding-top: 4px;
            margin-top: 4px;
          }
          .actionItem{
            cursor: pointer;
            list-style: none;
            padding: 7px 42px;
            color: #444;
            font-size: 14px;
            min-width: 100px;
            img{
              height: 15px;
              margin: -4px 4px -2px -22px;
            }
          }
          .actionItem.actionRed{
            color: red;
          }
          .actionItem:hover{
            background-color: #eee;
          }
        }
        .actionCnt.open{
          display: block;
        }
        .actionOverlay{
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
          display: none;
        }
        .actionOverlay.open{
          display: block;
        }
      }
      td.tdHeader{
        padding: 0;
      }
    }
    tbody{
      tr:hover{
        background-color: #f5f5f5;
        background-color: #f0f4ff;
        // cursor: pointer;
      }
    }
  }
</style>
